import css from 'styled-jsx/css';

const styles = css.global`.youtube-embed{width:100%;max-width:640px;margin:0 auto}.youtube-embed .player-wrapper{position:relative;width:100%;height:0;padding-bottom:56.25%;background:#000}.youtube-embed .player{position:absolute;top:0;left:0;width:100%;height:100%;border:0;display:block}`;

export default styles;